module.exports = __webpack_public_path__ + "media/images/pic/courses/group-banner-5f739b4b029081c986c37524d6ad77a5.png";